const custComplainApp = [
  {
    url: '/cust-complain-app/complaints/queryForbiddenCargoApplyList', // 禁止搜货申请 禁止发货申请
    coverFields: ['userPhone', 'userName']
  },
  {
    url: '/cust-complain-app/complaints/orderDetail', // 工单信息，少了两个敏感字段
    coverFields: [
      {
        field: 'data',
        keys: ['complainant', 'userPhone', 'defendantName', 'defendantTel']
      }
    ]
  },
  {
    url: '/cust-complain-app/complaints/wayBillDetail', // 运单信息
    coverFields: [
      {
        field: ['cargos', 'drivers'],
        keys: ['userPhone', 'kefuName', 'kefuTel', 'headName', 'headTel']
      }
    ]
  },
  {
    url: '/cust-complain-app/complaints/driver/trace',
    coverFields: [
      {
        field: 'trace',
        keys: ['number', 'address']
      }
    ]
  },
  // {
  //   url: '/cust-complain-app/complaints/driver/location', // 该接口已下线
  //   coverFields: [
  //     {
  //       field: 'businessList',
  //       keys: ['address', 'telephone']
  //     }
  //   ]
  // },
  // {
  //   url: '/cust-complain-app/payAccount/queryPayAuthInfo',
  //   coverFields: [
  //     {
  //       field: 'businessList',
  //       keys: []
  //     }
  //   ]
  // },
  // {
  //   url: '/cust-complain-app/payAccount/queryBalance',
  //   coverFields: [
  //     {
  //       field: 'businessList',
  //       keys: []
  //     }
  //   ]
  // },
  {
    url: '/cust-complain-app/payAccount/queryCashList', // bankCard 该字段目前暂时没有用到
    coverFields: [
      {
        field: 'cashFlowDTO',
        keys: ['bankCard']
      }
    ]
  },
  {
    url: '/cust-complain-app/trade/callRecords',
    coverFields: [
      {
        field: 'data',
        keys: ['callerNum ', 'calledNum']
      }
    ]
  },
  {
    url: '/cust-complain-app/user/queryUserRoleAccount',
    coverFields: ['cellphone']
  },
  {
    url: '/cust-complain-app/user/queryChangeMobileLog', // 手机号变更记录
    coverFields: ['oldTelephone', 'newTelephone']
  },
  {
    url: '/cust-complain-app/complaints/findContractsByOrderId', // 签署协议
    coverFields: [
      'proposerName',
      'proposerTelephone',
      'secondSignerTelephone',
      'signerName',
      'signerTelephone',
      'truckNumber',
      'loadAddress',
      'unloadAddress'
    ]
  }
]

export default custComplainApp
